import { render } from "./PasswordCreator.vue?vue&type=template&id=5d36de6c&scoped=true"
import script from "./PasswordCreator.vue?vue&type=script&lang=js"
export * from "./PasswordCreator.vue?vue&type=script&lang=js"

import "./PasswordCreator.vue?vue&type=style&index=0&id=5d36de6c&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d36de6c"]])

export default __exports__